import { render, staticRenderFns } from "./jobProfileDriverAssignSea.vue?vue&type=template&id=f5af153a&scoped=true&"
import script from "./jobProfileDriverAssignSea.vue?vue&type=script&lang=js&"
export * from "./jobProfileDriverAssignSea.vue?vue&type=script&lang=js&"
import style0 from "./jobProfileDriverAssignSea.vue?vue&type=style&index=0&id=f5af153a&scoped=true&lang=css&"
import style1 from "./jobProfileDriverAssignSea.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5af153a",
  null
  
)

export default component.exports